/**
 * Soft drifting cloud wisps along the top edge of a footer band.
 * Pure CSS shapes — no imagery. Honors prefers-reduced-motion.
 */
export function FooterClouds() {
  return (
    <div className="footer-clouds" aria-hidden="true">
      <div className="footer-cloud footer-cloud-a" />
      <div className="footer-cloud footer-cloud-b" />
      <div className="footer-cloud footer-cloud-c" />
      <div className="footer-cloud footer-cloud-d" />
    </div>
  );
}
